module.exports = __webpack_public_path__ + "img/pv1slt.036dcfc9.jpg";